import React from "react"

function Footer() {
  return (
    <footer className="text-center foooter">
      Made with ♥️ by Komal Mahto{" "}
      <i className="fa fa-copyright"> {new Date().getFullYear()}</i>
    </footer>
  )
}

export default Footer
